import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Div, Flex, Heading, Text } from "@hopper-ui/components";
import { NotebookIcon } from "@hopper-ui/icons";

export const SmartReportName = () => {
    const { tShared } = useSharedTranslation();

    return (
        <Flex
            alignItems="center"
            gap="inline-md"
            paddingX="inset-lg"
        >
            <Flex
                backgroundColor="neutral-weak"
                width="core_400"
                height="core_400"
                borderRadius="rounded-md"
                alignItems="center"
                justifyContent="center"
            >
                <NotebookIcon fill="neutral" />
            </Flex>
            <Div>
                <Text
                    size="sm"
                    color="neutral-weakest"
                >
                    {tShared("smartReports.reportName")}
                </Text>
                <Heading marginTop="inline-xs">{tShared("smartReports.engagementReportName")}</Heading>
            </Div>
        </Flex>
    );
};
